/* eslint-disable */
import React from 'react'
import http from '../../Component/Interceptor/Interseptor'
import {message} from 'antd'
import {Link} from 'react-router-dom'
import HeaderTable from '../BaseComponent/HeaderTable'
import Page from '../Pagination/Pagination'
import $ from 'jquery'
import {Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import SECURITY from '../BaseComponent/SECURITY'

class Roles extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      roles: [],
      modalDelete: false,
      cats: []
    }
  }
  componentDidMount() {
    $(function() {
      $('.filterBtn').on('click', function() {
        $('.filterComponent').slideToggle()
      })

      $('.cancelFilter').click(function() {
        $('.filterComponent').slideUp()
      })
    })

    http.get(`${SECURITY.SECURITY_MANAGE_LIST_ROLECATEGORY}`, {}).then((response) => {
      if (response.data.error == null) {
        this.setState({
          cats: response.data.object
        })
      } else {
        // message.error(response.data.description)
      }
    })

    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')
    http.get(`${SECURITY.SECURITY_REPORT_ROLE}?export=false&pageNumber=1&pageSize=10`, {}).then((response) => {
      if (response.data.error == null) {
        // alert(JSON.stringify(response.data))
        this.setState({
          roles: response.data.object.result,
          lengthProducts: response.data.object.countAll
        })
      } else {
        // message.error(response.data.description)
      }
    })
  }

  changeDropDown(data) {
    this.setState({
      roles: data,
      lengthProducts: sessionStorage.getItem('countAll')
    })
  }

  onResultFetched(data) {
    this.setState({
      roles: data
    })
  }

  filter() {
    var title = document.getElementById('title').value
    var category = document.getElementById('category').value
    var manageView = document.getElementById('manageView').value
    sessionStorage.setItem('params', `title=${title}&category=${category}&manageView=${manageView}`)

    http
      .get(
        `${
          SECURITY.SECURITY_REPORT_ROLE
        }?export=false&pageNumber=1&pageSize=10&title=${title}&category=${category}&manageView=${manageView}`,
        {}
      )
      .then((response) => {
        if (response.data.error == null) {
          this.setState({
            roles: response.data.object.result,
            lengthProducts: response.data.object.countAll
          })
        } else {
          this.setState({
            roles: []
          })
          // message.error(response.data.description)
        }
      })
  }
  deleteOk = () => {
    let id = sessionStorage.getItem('id')
    let data = {
      roleId: id
    }
    http.post(`${SECURITY.SECURITY_MANAGE_DELETE_ROLE}`, data, {}).then((response) => {
      if (response.data.error == null) {
        message.success('دسترسی با موفقیت حذف شد')
        http.get(`${SECURITY.SECURITY_REPORT_ROLE}?export=false&pageNumber=1&pageSize=10`, {}).then((response) => {
          if (response.data.error == null) {
            this.setState({
              roles: response.data.object.result,
              lengthProducts: response.data.object.countAll,
              modalDelete: !this.state.modalDelete
            })
          } else {
            // message.error(response.data.description)
          }
        })
      } else {
        // message.error(response.data.description)
      }
    })
  }
  deleteCancel = () => {
    this.setState({
      modalDelete: !this.state.modalDelete
    })
    sessionStorage.removeItem('id')
    sessionStorage.removeItem('title')
  }

  deleteRole = (rowId) => {
    let id = this.state.roles[rowId].id
    let title = this.state.roles[rowId].title
    sessionStorage.setItem('id', id)
    sessionStorage.setItem('title', title)
    this.setState({
      modalDelete: !this.state.modalDelete
    })
  }

  render() {
    let pageNumber = sessionStorage.getItem('pageNumber')
    let dropDownVal = sessionStorage.getItem('dropDownVal')
    let title = sessionStorage.getItem('title')
    let params = sessionStorage.getItem('params')

    let excelColumns = [
      {title: 'نام شهر', value: 'cityName'},
      {title: 'عرض جغرافیایی', value: 'latitude'},
      {title: 'نام استان', value: 'provinceName'},
      {title: 'طول جغرافیایی', value: 'longitude'}
    ]

    return (
      <div className="rtl printA4Page">
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>اطلاعات پایه</li>
            <li>کاربران</li>
            <li>نقش ها</li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderTable
                  addUrl="/addRole"
                  url={SECURITY.SECURITY_REPORT_ROLE}
                  ChangeDropDown={this.changeDropDown.bind(this)}
                  printUrl=""
                  printComponent=""
                  execelUrl={SECURITY.SECURITY_REPORT_ROLE + '?export=true'}
                  excelColumns={excelColumns}
                  titleAdd="افزودن شهر"
                  printLink=""
                />
                <button className="filterBtn">
                  <i className="fa fa-search" />
                </button>
              </div>
            </div>
            <div className="filterComponent">
              <div className="filterInputs">
                <div className="formComponent">
                  <label>عنوان</label>
                  <input className="form-control" id="title" type="text" />
                </div>
                <div className="formComponent">
                  <label>گروه</label>
                  <select className="form-control" name="category" id="category">
                    <option value="">------</option>
                    {this.state.cats.map((cat, index) => (
                      <option value={cat.id}>{cat.title}</option>
                    ))}
                  </select>
                </div>
                <div className="formComponent">
                  <label>مشاهده پنل مدیریت</label>
                  <select className="form-control" name="manageView" id="manageView">
                    <option value="">------</option>
                    <option value={1}>بله</option>
                    <option value={0}>خیر</option>
                  </select>
                </div>
              </div>
              <div className="filterOption">
                <button className="confirmFilter" onClick={this.filter.bind(this)}>
                  جست و جو
                </button>
              </div>
            </div>

            <div className="showBaseTable">
              <table className="baseTable">
                <tbody>
                  <tr className="firstRow">
                    <td>ردیف</td>
                    <td>عنوان</td>
                    <td>گروه</td>
                    <td>دیدن پنل مدیریت</td>
                    <td>کاربران</td>
                    <td>ویرایش</td>
                    <td>حذف</td>
                  </tr>

                  {this.state.roles.map((role, index) => (
                    <tr key={index}>
                      <td>{(pageNumber - 1) * dropDownVal + index + 1}</td>
                      <td>{role.title}</td>
                      <td>{role.categoryTitle}</td>
                      <td>{role.manageView ? 'بله' : 'خیر'}</td>
                      <td>
                        <Link target={'_blank'} to={role.id === 118 ? `/Drivers` : `/Operators/${role.id}`}>
                          <img src={require('../../image/details.svg')} alt={'edit'} />
                        </Link>
                      </td>

                      <td>
                        <Link to={`/editRole/${role.id}`}>
                          <img src={require('../../image/editDriver.svg')} alt={'edit'} />
                        </Link>
                      </td>
                      <td>
                        <button onClick={() => this.deleteRole(index)}>
                          <img src={require('../../image/trash.svg')} alt={'edit'} />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <Modal isOpen={this.state.modalDelete} toggle={this.deleteCancel} size="sm">
                <ModalHeader toggle={this.deleteCancel}>حذف دسترسی</ModalHeader>
                <ModalBody>
                  <p className="titleSm">آیا از حذف دسترسی {title} مطمئن هستید؟؟؟</p>
                </ModalBody>
                <ModalFooter>
                  <button className="confirmBtnModal" onClick={this.deleteOk}>
                    حذف دسترسی
                  </button>
                  <button className="cancelBtnModal" onClick={this.deleteCancel}>
                    لغو
                  </button>
                </ModalFooter>
              </Modal>
              <div className="paginationWrapp">
                <Page
                  defaultCurrent={1}
                  urlParams={params}
                  total={this.state.lengthProducts}
                  onResultFetched={this.onResultFetched.bind(this)}
                  url={SECURITY.SECURITY_REPORT_ROLE}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
export default Roles
